import { v4 as uuidV4 } from 'uuid';

import {
  type DerivedEventLegacy,
  type DerivedEventFilterLegacy,
  type FilterLegacy,
  DerivedEventTypeLegacy,
} from '@verantos-dev/types-cohorts';
import { Sequence_eventContext } from '@verantos-dev/util-cohort-builder-typescript-runtime';

import getActualValueFromDSL from './getActualValueFromDSL';
import { getEventName, getEventDateAttributes } from './getDerivedEventFilters';

const getSequenceEvents = (
  event: Sequence_eventContext | null,
  dirty?: boolean // set to true to annotate input fields as dirty
) => {
  try {
    const filters = event?.sequence_event_criteria()?.sequence_event_criterion();
    let anyOrder = false;
    const eventFilters: DerivedEventFilterLegacy[] = [];
    const temporalConstraints: FilterLegacy[] = [];
    if (filters) {
      filters.forEach((filter) => {
        if (filter.sequence_event_event()) {
          const event =
            filter?.sequence_event_event()?.selected_sequence_event() ||
            filter?.sequence_event_event()?.unselected_sequence_event();
          const isSelected = filter
            ?.sequence_event_event()
            ?.selected_sequence_event()
            ?.IS_EVENT_DATE()
            ?.getText()
            ? {
                isSelected: {
                  id: uuidV4(),
                  value: 'true',
                },
              }
            : {};
          eventFilters.push({
            id: uuidV4(),
            eventName: {
              id: uuidV4(),
              value: getEventName(event),
              dirty,
            },
            eventDateAttribute: {
              id: uuidV4(),
              value: getEventDateAttributes(event),
              dirty,
            },
            ...isSelected,
          });
        }
        if (filter?.sequence_event_constraint()?.ANY_ORDER()?.getText()) {
          anyOrder = true;
        }
        if (filter.sequence_event_constraint()?.temporal_constraint()) {
          const temporalConstraint = filter.sequence_event_constraint()?.temporal_constraint();
          const sequenceTemporalFilter = temporalConstraint?.sequence_temporal_filter();
          const temporalConstraintType =
            sequenceTemporalFilter?.MINIMUM_BETWEEN()?.getText() ||
            sequenceTemporalFilter?.MAXIMUM_BETWEEN()?.getText() ||
            sequenceTemporalFilter?.TOTAL_BETWEEN()?.getText();
          temporalConstraints.push({
            id: uuidV4(),
            inputFields: [
              {
                id: uuidV4(),
                value: temporalConstraintType || '',
                dirty,
              },
              {
                id: uuidV4(),
                value: sequenceTemporalFilter?.INT()?.getText() || '',
                dirty,
              },
              {
                id: uuidV4(),
                value: sequenceTemporalFilter?.TIME_UNIT()?.getText() || '',
                dirty,
              },
            ],
          });
        }
      });
    }
    return {
      id: uuidV4(),
      name: getActualValueFromDSL(event?.SEQUENCE_EVENT_NAME()?.getText()) || '',
      type: DerivedEventTypeLegacy.SEQUENCE,
      anyOrder,
      temporalConstraints,
      eventFilters,
      uniquenessFilters: [],
    };
  } catch (error) {
    console.error('Error fetching sequence events', error);
    return {} as DerivedEventLegacy;
  }
};

export default getSequenceEvents;
